// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBXwp4LiRSlKRDg7MgTrNHnLLvHKyoPee8",
  authDomain: "myvideo-1c73a.firebaseapp.com",
  projectId: "myvideo-1c73a",
  storageBucket: "myvideo-1c73a.appspot.com",
  messagingSenderId: "916605101755",
  appId: "1:916605101755:web:9f2e4497fcc69810bcab9e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;